require('./formBuilderLeftNav.i18n.json');
require('./formBuilderLeftNav.tpl.html');
require('./formBuilderLeftNavController.js');

const FormBuilderLeftNavComponent = {
    templateUrl: '/configuration/formEditor/content/form/leftNav/formBuilderLeftNav.tpl.html',
    controller: 'formBuilderLeftNavController',
    bindings: {}
};

angular.module('ums.configuration')
    .component('uiFormBuilderLeftNav', FormBuilderLeftNavComponent);
